import { AccordionItem } from './AccordionItem'

interface AccordionProps {
  children: React.ReactNode
}

export const Accordion = ({ children }: AccordionProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 16px',
        fontSize: '14px',
        lineHeight: '16px',
      }}
    >
      {children}
    </div>
  )
}

Accordion.Item = AccordionItem
